import React from "react";
import HeroSection from "./components/HeroSection";
import Services from "./components/Services";
import Trusted from "./components/Trusted";
import CarouselSec from "./components/CarouselSec";
import FeatureProduct from "./components/FeatureProduct";



const Home = () => {
  const data = {
    name: "CartFo store",
    img: "images/hero-1.png",
    qoutes:`Cartfo powers millions of businesses worldwide`
  };

  return (
    <>


      <CarouselSec />
      <HeroSection myData={data} />
      <FeatureProduct />
      <Services />
      <Trusted />


    </>
  )
};



export default Home;